import type { ErrorType } from '~/data/ErrorRecord';
import ErrorConstants from './constants';

export const showError = (error: ErrorType, view: any, persistant = false) => ({
  persistant,
  view,
  error,
  type: ErrorConstants.ERROR,
});

export const clearError = () => ({
  type: ErrorConstants.CLEAR_ERROR,
});

export const clearErrorFromView = (view: any) => ({
  view,
  type: ErrorConstants.CLEAR_ERROR_FROM_VIEW,
});
